// A component for apple like prompting password, which is using in email-verification step
// Needs a markup!

import { removeClass, addClass } from './utils';

class VerificationPrompterBox {
  constructor(params) {
    const {
      onChangeEmail, onResendCode, onFinished, onSuccess, onFail
    } = params;
    this.functions = {
      onChangeEmail, onResendCode, onFinished, onSuccess, onFail
    };
    this.handleInputEvent = this.handleInputEvent.bind(this);
    this.reflectOnPrompter = this.reflectOnPrompter.bind(this);
    this.setEmailAddress = this.setEmailAddress.bind(this);
    this.onResendCode = this.onResendCode.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.verificationCallback = this.verificationCallback.bind(this);
    this.clear = this.clear.bind(this);
    this.setLayoutElements.bind(this);
    this.init = this.init.bind(this);

    this.setLayoutElements(params);
    this.init();
    this.emailAddress = 'some@email.com';
  }

  get defaultSelectors() {
    return {
      input: '.jfEmailVerify-inside .jfInput-input',
      prompter: '.js-emailVerify-prompter',
      successIcon: '.js-emailVerify-statusIcon.js-forSuccess',
      failIcon: '.js-emailVerify-statusIcon.js-forFail',
      changeEmailButton: '.js-changeEmail',
      resendCodeButton: '.js-resendCode',
      sentVerificationText: '.jfEmailVerify-sentVerificationText',
      patienceText: '.jfEmailVerify-footer-patienceText',
      didntReceiveVerification: '.jfEmailVerify-didntReceiveVerification',
      or: '.jfEmailVerify-or'
    };
  }
  translate(formTranslation) {
    Object.keys(this.layoutElements).forEach((key) => {
      if (this.layoutElements[key.toString()].children.length > 0) return;
      this.layoutElements[key.toString()].textContent = formTranslation.translate(this.layoutElements[key.toString()].textContent);
    }, this);
    this.translateSentVerificationText(formTranslation);
  }

  translateSentVerificationText(formTranslation) {
    const sentVerificationTextHTML = formTranslation.translate('The verification code has been sent to <span {style}>some@email.com</span><br/>' +
      'Please check your mailbox and paste the code below to complete verification');
    const resendCodeButtonText = formTranslation.translate('RESEND CODE');
    const orText = formTranslation.translate('or');
    const didntReceiveVerificationText = formTranslation.translate("Didn't receive verification code?");
    const changeEmailButtonText = formTranslation.translate("CHANGE EMAIL");
    const patienceText = formTranslation.translate('Receiving the email may take a few minutes, thank you for your patience!');
    this.updateStyledEmail({
      sentVerificationTextHTML,
      resendCodeButtonText,
      orText,
      didntReceiveVerificationText,
      changeEmailButtonText,
      patienceText
    });
  }

  setLayoutElements(params) {
    const { container } = params;
    const selectors = Object.assign({}, this.defaultSelectors, (params.selectors || {}));
    this.layoutElements = Object.entries(selectors).reduce((acc, selector) => Object.assign(acc, { [selector[0]]: container.querySelector(selector[1]) }), { container });
  }

  init() {
    const {
      resendCodeButton, failIcon, changeEmailButton, input
    } = this.layoutElements;
    input.addEventListener('input', this.handleInputEvent);
    resendCodeButton.addEventListener('click', this.onResendCode);
    failIcon.addEventListener('click', this.clear);
    changeEmailButton.addEventListener('click', this.onChangeEmail);
  }

  setEmailAddress(mailAddress) {
    this.emailAddress = mailAddress;
    this.layoutElements.sentVerificationText.children[0].textContent = mailAddress;
  }

  updateStyledEmail({
    sentVerificationTextHTML,
    resendCodeButtonText,
    orText,
    didntReceiveVerificationText,
    changeEmailButtonText,
    patienceText
  }) {
    const { layoutElements, emailAddress } = this;

    const updateElement = (element, text) => {
      if (element && text) {
        element.innerHTML = text;
      }
    };
  
    updateElement(layoutElements.sentVerificationText, sentVerificationTextHTML && sentVerificationTextHTML.replace(/<span[^>]*>[\s\S]+<\/span>/,
      `<span style="color:#4a85ef">${emailAddress}</span>`));
    updateElement(layoutElements.resendCodeButton, resendCodeButtonText);
    updateElement(layoutElements.changeEmailButton, changeEmailButtonText);
    updateElement(layoutElements.patienceText, patienceText);
    updateElement(layoutElements.or, orText);
    updateElement(layoutElements.didntReceiveVerification, didntReceiveVerificationText);
  }

  clear(clearValue = false, clearIcons = true) {
    const { successIcon, failIcon, input } = this.layoutElements;
    if (clearIcons) {
      removeClass(successIcon, 'isVisible');
      removeClass(failIcon, 'isVisible');
    }
    if (clearValue) {
      input.setValue('');
      this.reflectOnPrompter('');
      input.focus();
    }
    if (input) {
      removeClass(input, 'validate[required]');
    }
  }

  onChangeEmail() {
    this.clear(true, true);
    this.functions.onChangeEmail();
  }

  onResendCode() {
    this.clear(true, true);
    this.functions.onResendCode();
  }

  /**
   * Left-pads the value with &bull;
   * @param value
  */
  reflectOnPrompter(value) {
    const { prompter } = this.layoutElements;
    let prompterValue = value;
    for (let i = value.length; i < 4; i++) {
      prompterValue += '<span>&bull;</span>';
    }
    prompter.innerHTML = prompterValue;
  }

  verificationCallback(status) {
    const { successIcon, failIcon } = this.layoutElements;
    if (status) {
      addClass(successIcon, 'isVisible');
      this.functions.onSuccess();
    } else {
      addClass(failIcon, 'isVisible');
      this.functions.onFail();
    }
  }

  handleInputEvent(event) {
    const { onFinished } = this.functions;
    const { input } = this.layoutElements;
    // Keyboard ArrowUp & ArrowDown should be prevented
    if (event.which === 38 || event.which === 40) {
      event.preventDefault();
    }

    let { value } = event.target;

    if (value.length > 4) {
      value = value.substring(0, 4);
      input.value = value;
    }

    switch (value.length) {
      case 4:
        onFinished(value, this.verificationCallback);
        break;
      default:
        this.clear();
        break;
    }
    this.reflectOnPrompter(value);
  }
}

export default VerificationPrompterBox;
